import { render, staticRenderFns } from "./DashboardTile.vue?vue&type=template&id=48136e57&"
import script from "./DashboardTile.vue?vue&type=script&lang=ts&"
export * from "./DashboardTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports